import React, { useState } from "react";
import { useApp } from "../../context/AppContext";
import { downloadPDF } from "../../utils/pdf";
import { formatINR, currentMonth } from "../../utils/helpers";
import { CreditCard, Check, AlertTriangle , Download } from "lucide-react";

export default function Payroll() {
  const { team, payments, recordPayment } = useApp();
  const [confirmPay, setConfirmPay] = useState(null);
  const active = team.filter(m => m.status === "Active");
  const month = currentMonth();
  const totalPayroll = active.reduce((s, m) => s + m.salary, 0);
  const isPaid = (id) => payments.some(p => p.memberId === id && p.month === month && p.status === "Paid");

  // BUG-16 FIX: Double-click to confirm
  const handlePay = (member) => {
    if (isPaid(member.id)) return;
    if (confirmPay === member.id) {
      recordPayment({ memberId: member.id, memberName: member.name, amount: member.salary, currency: member.salaryCurrency });
      setConfirmPay(null);
    } else {
      setConfirmPay(member.id);
      setTimeout(() => setConfirmPay(null), 3000);
    }
  };

  const paidCount = active.filter(m => isPaid(m.id)).length;
  const paidAmount = active.filter(m => isPaid(m.id)).reduce((s, m) => s + m.salary, 0);

  
  const exportPayrollPDF = () => {
    downloadPDF("Payroll Report",
      ["Employee", "Role", "Salary", "Status", "Cycle"],
      team.filter(m => m.status === "Active").map(m => [m.name, m.role, formatINR(m.salary), m.status, m.salaryCycle || "Monthly"]),
      [
        { label: "Monthly Payroll", value: formatINR(team.filter(m => m.status === "Active").reduce((s,m) => s + Number(m.salary), 0)), color: "#3B82F6" },
        { label: "Active Members", value: team.filter(m => m.status === "Active").length + "" },
      ]
    );
  };

  return (
    <div className="page-content">
      <div className="page-header">
        <div>
          <h3>Payroll — {new Date().toLocaleDateString("en-IN",{month:"long",year:"numeric"})}</h3>
          <span className="text-muted">{paidCount}/{active.length} paid | {formatINR(paidAmount)} of {formatINR(totalPayroll)}</span>
        </div>
        <button className="btn-ghost" onClick={exportPayrollPDF} style={{display:"flex",alignItems:"center",gap:6}}><Download size={14}/> PDF</button>
      </div>
      <div className="stats-grid" style={{gridTemplateColumns:"repeat(3,1fr)",marginBottom:20}}>
        <div className="stat-card gold"><div className="stat-label">Total Payroll</div><div className="stat-value">{formatINR(totalPayroll)}</div></div>
        <div className="stat-card green"><div className="stat-label">Paid</div><div className="stat-value">{formatINR(paidAmount)}</div></div>
        <div className="stat-card" style={{borderColor:"rgba(239,68,68,.15)"}}><div className="stat-label">Pending</div><div className="stat-value">{formatINR(totalPayroll-paidAmount)}</div></div>
      </div>
      <div className="table-card">
        <table>
          <thead><tr><th>Employee</th><th>Role</th><th>Salary</th><th>Status</th><th>Action</th></tr></thead>
          <tbody>
            {active.map(m => (
              <tr key={m.id}>
                <td className="primary">{m.name}</td>
                <td className="text-muted">{m.role}</td>
                <td className="mono amount">{formatINR(m.salary)}</td>
                <td><span className={"status-badge "+(isPaid(m.id)?"active":"inactive")}>{isPaid(m.id)?"Paid":"Pending"}</span></td>
                <td>{isPaid(m.id) ? (
                  <span style={{color:"var(--green)",fontSize:12,display:"flex",alignItems:"center",gap:4}}><Check size={14}/>Done</span>
                ) : (
                  <button className={confirmPay===m.id?"btn-gold confirming":"btn-gold"} style={{padding:"6px 14px",fontSize:12}} onClick={() => handlePay(m)}>
                    {confirmPay===m.id?<><AlertTriangle size={14}/> Confirm?</>:<><CreditCard size={14}/> Mark Paid</>}
                  </button>
                )}</td>
              </tr>
            ))}
            {active.length===0&&<tr><td colSpan={5} className="empty-row">No active team members.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
